import { Component, Input } from '@angular/core';
import { Border } from './border';

@Component({
    selector: 'app-standard-container',
    templateUrl: './standard-container.component.html',
    standalone: false,
})
export class StandardContainerComponent {
    public borderType = Border;

    @Input() public isDataGridContainer: boolean;
    @Input() public displayHeader = true;
    @Input() public displayFooter = false;
    @Input() public border: Border = Border.all;
    @Input() public borderRadius = true;
}
